<template>
  <div class="login-form-container">
    <el-tabs :tab-position="contactTab" @tab-click="tabClick">
      <el-tab-pane label="二维码登录">
        <div class="QR-code-login-wrap">
          <p>扫描二维码登录</p>
          <div class="QR-code-container" v-if="showQrCode" v-loading="loadCode">
            <vue-qr
              :logoSrc="config.imagePath"
              :text="config.value"
              :size="125"
              :margin="0"
            ></vue-qr>
          </div>
          <div class="refresh-code-wrap" v-else>
            <p class="expired-tip">二维码已过期</p>
            <p class="refresh-btn" @click="refreshQrCode">刷新</p>
          </div>
          <p class="scan-tip">请使用最新版传联APP扫码</p>
          <p>
            <a href="/register" target="_blank" class="new-user">新用户注册</a>
          </p>
        </div>
      </el-tab-pane>
      <el-tab-pane label="帐号登录">
        <div class="account-login-wrap">
          <div class="login-logo-wrap">
            <img src="../assets/image/cl_login_logo.png" alt />
            <p class="product-name">传 联</p>
          </div>
          <div class="login-form-wrap">
            <el-form
              :model="loginForm"
              :disabled="forbitLogin"
              :rules="loginRules"
              ref="loginForm"
              @submit.native.prevent
              class="account-login-form"
            >
              <el-form-item prop="account" class="profile-form-item">
                <div class="sefety-item-input">
                  <el-input
                    v-model="loginForm.account"
                    @input="valueChange"
                    placeholder="请输入手机号 / 传联号"
                  >
                    <i slot="prefix" class="el-input__icon el-icon-user"></i>
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item prop="password" class="profile-form-item">
                <div class="sefety-item-input">
                  <el-input
                    show-password
                    v-model="loginForm.password"
                    @input="valueChange"
                    placeholder="请输入密码"
                  >
                    <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                  </el-input>
                </div>
              </el-form-item>
              <div class="link-btn-wrap flex">
                <a class="find-password" href="/forget" target="_blank"
                  >忘记密码？</a
                >
                <span :class="loginTip.class">{{ loginTip.text }}</span>
                <a class="new-user" href="/register" target="_blank"
                  >新用户注册</a
                >
              </div>
              <el-form-item class="submit-item">
                <el-button
                  type="primary"
                  native-type="submit"
                  class="cl-login-btn"
                  @click="submitForm('loginForm')"
                  >登录</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { apiMap } from "../utils/apiMap";
import { _debounce } from "../utils/feed";
import VueQr from "vue-qr";
export default {
  name: "login-form",
  data() {
    var validateAccount = (rule, value, callback) => {
      var numberRegExp = /^[0-9 ]*$/;
      if (value === "") {
        callback(new Error("请输入帐号"));
      } else if (!numberRegExp.test(value)) {
        callback(new Error("账号只能是数字，且不能有空格"));
      } else {
        this.loginForm.account = value.replace(/\s*/g, "");
        callback();
      }
    };
    return {
      contactTab: "top",
      forbitLogin: false,
      loginForm: {
        account: "",
        password: "",
      },
      loginRules: {
        account: [{ validator: validateAccount, trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      loginTip: {
        class: "",
        text: "",
      },
      showQrCode: true,
      loadCode: true,
      getCode: true,
      getTimer: null,
      config: {
        value: "",
        imagePath: require("../assets/image/cl_index_banner_logo.png"),
      },
      loginCode: "",
      fetchLogin: false,
    };
  },
  components: {
    VueQr,
  },
  mounted() {
    this.getCodeUrl(1);
  },
  beforeDestroy() {
    if (this.getTimer != null) {
      clearInterval(this.getTimer);
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginHandLian();
        } else {
          return false;
        }
      });
    },
    clearValidate(formName) {
      this.$refs[formName].clearValidate();
    },
    loginHandLian() {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["login"]["method"],
          url: apiMap["login"]["url"],
          // headers: { encode: "1" },
          data: `account=${_this.loginForm.account}&password=${_this.loginForm.password}`,

          timeout: 5000,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.loginTip = {
              class: "successful",
              text: "登录成功",
            };
            _this.forbitLogin = true;
            let loginInfo = response.data.result.data;
            // const token = $this.user.password;
            // localStorage.setItem("wxpyqToken", token);

            // 解析token headImgUrl
            // const decode = jwt_decode(token);
            // 存储数据
            if (!loginInfo.thumbHeadImg) {
              loginInfo.avatar = Store.state.defaultAvatar.C2C;
            } else {
              loginInfo.avatar = loginInfo.thumbHeadImg;
            }
            sessionStorage.setItem("userInfo", JSON.stringify(loginInfo));
            let userInfo = Base64.encode(JSON.stringify(loginInfo));
            sessionStorage.setItem("USER_INFO", JSON.stringify(userInfo));
            Store.dispatch("setUser", loginInfo);
            // 页面跳转
            setTimeout(() => {
              Router.push("/home");
            }, 700);
          } else {
            _this.loginTip = {
              class: "failed",
              text: response.data.result.data,
            };
          }
        })
        .catch(function(error) {
          if (error.message.includes("timeout")) {
            _this.loginTip = {
              class: "failed",
              text: "登录超时",
            };
          }
        });
    },
    valueChange(value) {
      this.loginTip = {
        class: "",
        text: "",
      };
    },
    tabClick(instant) {
      if (instant.index == "0") {
        if (this.fetchLogin == true) {
          return false;
        } else if (this.showQrCode == true) {
          this.scanResult();
        }
      } else {
        this.clearValidate("loginForm");
      }
    },
    scanResult() {
      let _this = this;
      _this.fetchLogin = true;
      _this.getTimer = setInterval(function() {
        _this.checkIfScanCode(function(response) {
          if (response.result.statusCode == 1) {
            _this.fetchLogin = false;
            clearInterval(_this.getTimer);
            _this.getTimer = null;
            _this.$message({
              message: "登录成功，正在跳转",
              type: "success",
              duration: 2000,
            });
            let loginInfo = response.result.data;
            // const token = $this.user.password;
            // localStorage.setItem("wxpyqToken", token);

            // 解析token headImgUrl
            // const decode = jwt_decode(token);
            // 存储数据
            if (!loginInfo.thumbHeadImg) {
              loginInfo.avatar = Store.state.defaultAvatar.C2C;
            } else {
              loginInfo.avatar = loginInfo.thumbHeadImg;
            }
            sessionStorage.setItem("userInfo", JSON.stringify(loginInfo));
            Store.dispatch("setUser", loginInfo);
            // 页面跳转
            setTimeout(() => {
              Router.push("/home");
            }, 1000);
          }
        });
      }, 2000);
      setTimeout(function() {
        clearInterval(_this.getTimer);
        _this.showQrCode = false;
        _this.fetchLogin = false;
        _this.getTimer = null;
      }, 300 * 1000);
    },
    checkIfScanCode(okCbk) {
      let _this = this;
      if (_this.loginCode == "") {
        return false;
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["qrCodeLogin"]["method"],
          url: apiMap["qrCodeLogin"]["url"],
          data: `code=${_this.loginCode}`,
          timeout: 5000,
        })
        .then(function(response) {
          okCbk(response.data);
        })
        .catch(function(error) {
          if (error.message.includes("timeout")) {
            _this.scanResult();
          }
        });
    },
    refreshQrCode() {
      this.loadCode = true;
      this.getCodeUrl(1);
    },
    getCodeUrl(scene) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["loginQrCode"]["method"],
          url: apiMap["loginQrCode"]["url"],
          timeout: 5000,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.showQrCode = true;
            _this.config.value = response.data.result.data.apiUri.split("?")[1];
            _this.loginCode = response.data.result.data.qrcode;
            _this.loadCode = false;
            if (scene == 1) {
              _this.scanResult();
            }
          } else {
            _this.showQrCode = false;
          }
        })
        .catch(function(error) {
          if (error.message.includes("timeout")) {
            _this.showQrCode = false;
          }
        });
    },
  },
};
</script>
<style scoped>
.login-form-container {
  padding: 0 15px 15px;
}

.account-login-wrap,
.QR-code-login-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.QR-code-login-wrap {
  margin: 62px 0 62px 0;
}

.product-name {
  margin: 10px 0;
  padding: 0 4px;
  text-align-last: justify;
  text-align: justify;
  text-justify: distribute-all-lines;
  font-size: 16px;
  font-weight: bold;
}

.login-form-wrap {
  width: 290px;
}

.cl-login-account {
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 25px;
  background-repeat: no-repeat;
  background-image: url("../assets/icon/cl_login_account.png");
}

.cl-login-psw {
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 25px;
  background-repeat: no-repeat;
  background-position: 3px 9px;
  background-image: url("../assets/icon/cl_login_password.png");
}

.link-btn-wrap {
  margin-bottom: 13px;
  font-size: 12px;
  justify-content: space-between;
}

.link-btn-wrap .successful {
  color: #009900;
}

.link-btn-wrap .failed {
  color: #ff0000;
}

.find-password {
  color: #000;
}

.new-user {
  color: #1a70db;
}

.submit-item {
  margin-bottom: 0;
}

.cl-login-btn {
  width: 100%;
  padding: 8px 20px;
  font-size: 18px;
}

.refresh-code-wrap {
  display: flex;
  flex-direction: column;
  width: 125px;
  height: 125px;
  margin: 10px 0 5px;
  justify-content: center;
  align-items: center;
  line-height: 25px;
  border: 1px solid #cccccc;
}

.QR-code-container {
  width: 125px;
  height: 125px;
  margin: 15px 0 5px;
}

.expired-tip {
  color: #888;
}

.refresh-btn {
  cursor: pointer;
  color: #1a70db;
}

.scan-tip {
  line-height: 30px;
}
</style>
